const CAP63 ={
  "id": 212,
  "title": "Bitcoin en la práctica: ¿cómo se utiliza?",
  "slug": "bitcoin-en-la-practica",
  "type": "lesson",
  "category": "bitcoin-basico",
  "level": "basic",
  "preview": "Bitcoin puede utilizarse de forma sencilla mediante wallets, direcciones y transacciones. Aunque la tecnología detrás es compleja, su uso es tan fácil como enviar un mensaje por WhatsApp.",
  "sections": [
    {
      "heading": "Bitcoin: fácil de usar para cualquiera",
      "text": [
        "Si sabes utilizar WhatsApp, sabes usar Bitcoin.",
        "Bitcoin tiene muchas complicaciones técnicas internas, pero utilizarlo —enviar, recibir y almacenar BTC— es extremadamente sencillo.",
        "Al igual que puedes usar el correo sin entender protocolos como SMTP o TCP/IP, puedes usar Bitcoin sin conocer sus fundamentos técnicos. Aun así, si deseas profundizar, puedes continuar tu formación técnica en Bit2Me Academy.",
        "En este capítulo se resumen los elementos más importantes para usar Bitcoin en la práctica."
      ]
    },
    {
      "heading": "El monedero (Wallet)",
      "text": [
        "Bitcoin, al ser dinero puramente digital, necesita un programa que hable su mismo lenguaje: un monedero o wallet.",
        "Un wallet puede instalarse en ordenador o smartphone, o puede utilizarse vía web. Para la mayoría de principiantes, las wallets web son las más rápidas y cómodas.",
        "Un ejemplo de monedero multicripto es Bit2Me Wallet."
      ]
    },
    {
      "heading": "Las direcciones",
      "text": [
        "El monedero puede crear direcciones Bitcoin. Estas direcciones son equivalentes conceptualmente a un número de cuenta bancaria, pero sin bancos intermediarios y con la capacidad de crear tantas como quieras.",
        "Para recibir bitcoin, solo debes compartir una dirección de tu monedero. Para enviar bitcoin, debes conocer una dirección de la otra persona.",
        "Las direcciones pueden mostrarse como texto o como código QR.",
        "Compartir una dirección no implica riesgo de robo, del mismo modo que compartir tu dirección de email no permite que otros envíen correos desde ella."
      ]
    },
    {
      "heading": "Las transacciones",
      "text": [
        "Lo que se envía por la red Bitcoin son bitcoin o satoshis, no euros ni dólares. Su equivalente en divisas cambia minuto a minuto.",
        "Si alguien te pide 100 € en Bitcoin, deberás enviar la cantidad de BTC que equivalga a 100 € en ese momento.",
        "Dado que Bitcoin aún está en una etapa temprana de crecimiento, su precio es volátil. Los usuarios lo entienden y aceptan pequeñas variaciones.",
        "Para evitar la volatilidad puedes enviar SAT exactos con un tiempo límite para el pago. Ejemplo: si 100 € equivalen a 0,002 BTC, puedes pedir que te paguen esa cantidad en máximo una hora."
      ]
    },
    {
      "heading": "Los mineros y las confirmaciones",
      "text": [
        "El envío de BTC es instantáneo, pero para que la transacción sea confirmada debe recibir al menos una validación de los mineros.",
        "En Bitcoin nadie te obliga a pagar una comisión exacta. Tú decides cuánto pagar según la urgencia.",
        "Los mineros procesan unas 2.000 transacciones cada 10 minutos. Se priorizan las que pagan mayor comisión.",
        "Si pagas una comisión baja, tu transacción puede tardar más en confirmarse.",
        "Por regla general, la primera confirmación suele llegar en unos 10 minutos."
      ]
    },
    {
      "heading": "Anonimato en Bitcoin",
      "text": [
        "Bitcoin no es anónimo: es seudónimo.",
        "Todas las transacciones son visibles públicamente en la Blockchain.",
        "Aunque las transacciones no incluyen nombres, sí existen métodos para analizar y vincular direcciones con identidades."
      ]
    },
    {
      "heading": "Qué aprenderás a continuación",
      "list": [
        "Cómo enviar y recibir bitcoin",
        "Dónde usar Bitcoin",
        "Cómo se fija su precio",
        "Cómo funciona la Red Bitcoin",
        "Cómo cambiar bitcoin por otras criptomonedas",
        "Y mucho más…"
      ]
    }
  ]
}

export default CAP63;
